import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageContainer from '~/containers/Page';
import GridView from '~/components/gridView';
import FilterBarWrapper from './FilterBarWrapper';
import CardView from '~/components/cardView';
import { Suspense } from 'react';
import { Spinner } from '@nike/podium';
import { useParams } from 'react-router-dom';
const ProductDirectoryPage = () => {
    const { viewType } = useParams();
    const isCardView = viewType === 'card';
    return (_jsxs(PageContainer, { title: "Product Lines", children: [_jsx(FilterBarWrapper, {}), _jsx(Suspense, { fallback: _jsx(Spinner, {}), children: _jsx("div", { className: "h-full flex flex-col", children: _jsx("div", { className: "flex-1 min-h-0", children: isCardView ? _jsx(CardView, {}) : _jsx(GridView, { className: "h-full" }) }) }) })] }));
};
export default ProductDirectoryPage;
